module.exports = __webpack_public_path__ + "static/media/vehicle-register-blurred.1746d225.jpg";